import React, { useState, useEffect, Fragment } from "react";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { map } from "lodash";
import BreadcrumbLink from "../../components/Common/BreadcrumbLink";
import i18n from "../../i18n";
import { listPlaces, listScheduledType } from "../../common/data";
import Spinners from "../../components/Common/Spinner";
import CardServiceV2 from "./CardServiceV2";
import RequestServiceCancelModal from "./RequestServiceCancelModal";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import { WebsocketService } from "./WebsocketService";
import { getOrgsAdmin, getEmployeeRequests, getImportCokeRoutes, getTaskProgress } from "../../helpers/api_rombo_helper";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import AlertError from "../../components/Alerts/AlertError";
import { createSelector } from "reselect";
import { FilterType, StreamType, TypeService, Permissions, DataActions, ServiceStatus, UserType } from "../../constants/enums";
import { orgId, handleSearchFilters } from "../../constants/utils";
import folderNoResults from "../../assets/images/questionmark-folder.png";
import downloadDocument from "../../assets/images/downdoc.png";
import hourGlass from "../../assets/images/hourglass.png";
import { UserCheckCircle, UserQuestionCircle } from "../../assets/images/icons/CustomIcons";

const GeneralServices = (props) => {
  document.title = `${i18n.t("General")} - ${orgId}`;

  const savedFilters = JSON.parse(localStorage.getItem("requestFilters")) || {
    eventType: "sendMessage",
    metadata: { platform: "WEB" },
    data: { action: DataActions.GET_REQUESTS, filters: { page: 1, size: 10, status: ServiceStatus.UNASSIGNED } },
  };

  const [statusFilters, setStatusFilters] = useState({
    [ServiceStatus.UNASSIGNED]: {},
    [ServiceStatus.ASSIGNED]: {},
    [ServiceStatus.STARTED]: {},
  });

  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [reloadList, setReloadList] = useState(true);
  const [drp_link, setDrp_link] = useState(false);
  const [findServices, setFindServices] = useState([]);
  const [listServices, setListServices] = useState({ page: 1, size: 10, pages: 1, items: [] });
  const [requestServiceCancelModal, setRequestServiceCancelModal] = useState(false);
  const toggleViewModalCancelService = () => setRequestServiceCancelModal(!requestServiceCancelModal);
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [clickAssignService, setClickAssignService] = useState(false);
  const [showNoResults, setShowNoResults] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const [errorBody, setErrorBody] = useState("");
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');
  const [listCompanies, setListCompanies] = useState([]);
  const [selectedService, setSelectedService] = useState({});
  const [isImporting, setIsImporting] = useState(false);
  const [importStatus, setImportStatus] = useState(null);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [activeStatus, setActiveStatus] = useState(savedFilters.data?.filters?.status || ServiceStatus.UNASSIGNED);  
  const [fCompany, setFCompany] = useState(savedFilters.data?.filters?.partner_id || null);
  const [typeService, setTypeService] = useState(savedFilters.data?.filters?.type || null);
  const [statusService, setStatusService] = useState(savedFilters.data?.filters?.status || null);
  const [serviceNumber, setServiceNumber] = useState(savedFilters.data?.filters?.code || null);
  const [placeService, setPlaceService] = useState(savedFilters.data?.filters?.place_id || null);
  const [plateService, setPlateService] = useState(savedFilters.data?.filters?.plate || null);
  const [scheduledType, setScheduledType] =useState(savedFilters.data?.filters?.scheduled_type || null);

  const [currentPage, setCurrentPage] = useState(savedFilters.data?.filters?.page || 1);
  const [recordsPerPage] = useState(7);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const [currentRecords, setCurrentRecords] = useState(findServices.slice(indexOfFirstRecord, indexOfLastRecord));
  const nPages = Math.ceil(findServices.length / recordsPerPage);
  const [filtersOpts, setFiltersOpts] = useState(savedFilters);

  const autoformik = useFormik({
    initialValues: {
      search: "",
      serviceNumber: "",
      status: "",
      type: "",
      place_id: "",
      plate: "",
      scheduled_type: "",
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      serviceNumber: Yup.string(),
      status: Yup.string(),
      type: Yup.string(),
      place_id: Yup.string(),
      plate: Yup.string(),
      scheduled_type: Yup.string(),
    }),
  });

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  const isEmployee = infoUser.roles === UserType.EMPLOYEE;

  const fetchEmployeeRequests = async () => {
    try {
      const response = await getEmployeeRequests(token, {
        page: 1,
        size: 10,
        status: ServiceStatus.UNASSIGNED,
      });
      setListServices({
        page: response.page,
        size: response.size,
        pages: response.pages,
        items: response.items,
      });
      setFindServices(response.items);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching employee requests:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEmployee) {
      fetchEmployeeRequests();
    } else {
      const savedFilters = localStorage.getItem("requestFilters");
      if (savedFilters) {
        const parsedFilters = JSON.parse(savedFilters);
        setFiltersOpts(parsedFilters);
        setCurrentPage(parsedFilters.data.filters.page || 1);
      }
    }
  }, [isEmployee]);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
      
      if (!data.data.is_staff) {
        searchFilters(data.data.partner_id, "company");
      }
    }
  }, [data, loading]);
  
  useEffect(() => {
    setFindServices(listServices.items);
  }, [listServices]);

  const searchFilters = (val, typeSearch) => {
    handleSearchFilters(
      val,
      typeSearch,
      filtersOpts,
      setFiltersOpts,
      setReloadList,
      setCurrentPage,
      "requestFilters",
      {
        setFCompany,
        setStatusService,
        setTypeService,
        setServiceNumber,
        setPlaceService,
        setPlateService,
        setScheduledType
      }
    );
  };

  const onGetOrgsAdmin = () => {
    let arr = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.forEach((item) => {
          arr.push({ label: item.name, value: item.partner_id });
        });
        setListCompanies([...arr]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
      });
  };

  useEffect(() => {
    onGetOrgsAdmin();
  
    const checkNotification = () => {
      const shouldNotify = localStorage.getItem("notify") === "true";
      if (shouldNotify) {
        setShowAlertSuccess(true);
        setTextHeader(localStorage.getItem("headerText") || "");
        setTextBody(localStorage.getItem("bodyText") || "");
        localStorage.setItem("notify", "false");
      }
    };
  
    checkNotification();
  
    const handleStorageChange = (e) => {
      if (e.key === "notify") {
        checkNotification();
      }
    };
  
    window.addEventListener("storage", handleStorageChange);
  
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);  

  useEffect(() => {
    if (isLoading || findServices.length > 0) {
      setShowNoResults(false);
    }

    if (!isLoading && findServices.length === 0) {
      const timer = setTimeout(() => {
        setShowNoResults(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isLoading, findServices]);

  useEffect(() => {
    localStorage.setItem("requestFilters", JSON.stringify(filtersOpts));
  }, [filtersOpts]);

  const handleStatusChange = (newStatus, actionType) => {
    setStatusFilters((prev) => ({
      ...prev,
      [activeStatus]: {
        fCompany,
        typeService,
        statusService,
        serviceNumber,
        placeService,
        plateService,
        scheduledType,
        filtersOpts
      },
    }));
  
    const saved = statusFilters[newStatus] || {};

    setFCompany(saved.fCompany || null);
    setTypeService(saved.typeService || null);
    setStatusService(saved.statusService || null);
    setServiceNumber(saved.serviceNumber || "");
    setPlaceService(saved.placeService || null);
    setPlateService(saved.plateService || "");
    setScheduledType(saved.scheduledType || null);
  
    setFiltersOpts(
      saved.filtersOpts || {
        eventType: "sendMessage",
        metadata: { platform: "WEB", screen: "MAIN" },
        data: {
          action: actionType,
          filters: { page: 1, size: 10, status: newStatus },
        },
      }
    );
  
    if (!statusFilters[newStatus]) {
      setServiceNumber("");
      setPlateService("");
      setPlaceService(null);
      setScheduledType(null);
      setTypeService(null);
      setFCompany(null);
    }
  
    setActiveStatus(newStatus);
    setCurrentPage(1);
    setReloadList(true);
  };
  
  useEffect(() => {
    localStorage.setItem("statusFilters", JSON.stringify(statusFilters));
  }, [statusFilters]);

  useEffect(() => {
    const savedStatusFilters = localStorage.getItem("statusFilters");
    if (savedStatusFilters) {
      setStatusFilters(JSON.parse(savedStatusFilters));
    }
  }, []);

  const checkImportProgress = async (taskId) => {
    try {
      const progress = await getTaskProgress(token, taskId);
      
      if (progress.complete) {
        setIsImporting(false);
        setCurrentTaskId(null);
        
        if (progress.status === "SUCCESS") {
          setShowAlertSuccess(true);
          setTextHeader(i18n.t("ImportCompleted"));
          setTextBody(i18n.t("ServicesSyncedSuccessfully"));
        } else if (progress.status === "FAILURE" || progress.status === "FAILED") {
          setShowAlertError(true);
          setErrorHeader(i18n.t("NoServicesAvailableHeader"));
          setErrorBody(i18n.t("NoServicesAvailableBody"));
        } else if (progress.status === "RETRY") {
          setShowAlertError(true);
          setErrorHeader(i18n.t("ImportRetryHeader"));
          setErrorBody(i18n.t("ImportRetryBody"));
        } else {
          console.error("Import status unknown:", progress.status);
        }
        return;
      }
      
      if (progress.status === "STARTED" || progress.status === "PENDING" || progress.status === "RETRY") {
        setTimeout(() => checkImportProgress(taskId), 15000);
      } else {
        setIsImporting(false);
        setCurrentTaskId(null);
        setShowAlertError(true);
        setErrorHeader(i18n.t("NoServicesAvailableHeader"));
        setErrorBody(i18n.t("NoServicesAvailableBody"));
      }
    } catch (error) {
      console.error("Error checking progress:", error);
      setIsImporting(false);
      setCurrentTaskId(null);
      setShowAlertError(true);
      setErrorHeader(i18n.t("ProgressCheckErrorHeader"));
      setErrorBody(error.message || i18n.t("UnknownError"));
    }
  };

  const handleImportClick = async () => {
    setIsImporting(true);
    try {
      const response = await getImportCokeRoutes(token);
      
      if (response.task_id) {
        setCurrentTaskId(response.task_id);
        setTimeout(() => checkImportProgress(response.task_id), 2000);
      } else {
        setIsImporting(false);
        console.error("No task_id was received in the response");
      }
    } catch (error) {
      console.error("Error starting import:", error);
      setIsImporting(false);
      setCurrentTaskId(null);
    }
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink title={i18n.t("Services")} link='/services/request' breadcrumbItem={i18n.t("Requests")} />                   
          <Row>
            <Card>
              <CardBody>
                <Row className="pb-2">
                  <Col xxl={9} md={7} xs={12}>
                    <CardTitle className="h4">{i18n.t("Services")}</CardTitle>
                    {!isLoading && (
                      <>
                        {(!infoUser.permissions.includes(Permissions.SERVICES_READ)) ? (
                          <span className="error-message-requests">
                            <i className="fa fa-exclamation-circle" />
                            {i18n.t("NoPermissionsViewServices")}
                          </span>
                        ) : (
                          listServices.items.length === 0 && showNoResults && (
                            <span className="error-message-requests">
                              <i className="fa fa-exclamation-circle" />
                              {i18n.t("ServiceRequestsCouldNotBeLoaded")}
                            </span>
                          )
                        )}
                      </>
                    )}
                  </Col>
                  <Col xxl={3} md={5} xs={12} className="text-end">
                    <Row>
                      <Col xxl={12} md={12} xs={12}>
                        {infoUser.permissions && infoUser.permissions.includes(Permissions.SERVICES_CREATE) && (
                          <div className="d-inline-flex align-items-center gap-3">
                            <Dropdown isOpen={drp_link} toggle={() => setDrp_link(!drp_link)}>
                              <DropdownToggle caret className="btn btn-request border">
                                {i18n.t("RequestAService")}
                              </DropdownToggle>
                              <DropdownMenu className="custom-dropdown-menu custom-dropdown-menu-sm dropdown-menu-end border-0">
                                <DropdownItem tag={Link}
                                  to={
                                    [3867, 4355, 7784].includes(Number(fCompany)) ||
                                    [3867, 4355, 7784].includes(Number(infoUser.partner_id))
                                      ? "/services/express-request/create"
                                      : "/services/request/create"
                                  }
                                >
                                  {i18n.t("RegularService")}
                                </DropdownItem>
                                <DropdownItem tag={Link} to="/services/route-request/create">
                                  {i18n.t("RouteService")}
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                            {infoUser.is_staff && [1, 6823].includes(fCompany) && (
                              <button 
                                className="btn-import-coke"
                                onClick={handleImportClick}
                                disabled={isImporting}
                              >
                                <img 
                                  src={isImporting ? hourGlass : downloadDocument} 
                                  alt={isImporting ? "Processing" : "Download"}  
                                  className="import-coke-icon"
                                />
                              </button>
                            )}
                            <button 
                              className="btn-import-coke"
                              onClick={() => window.location.reload()}
                            >
                               <i className="bx bx-revision" />
                            </button>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                <div className="orange-separator" />
                  <Col className="d-flex flex-wrap justify-content-start status-buttons-container">
                    <div className="d-none d-md-flex flex-wrap gap-2">
                      <button
                        className={`btn btn-status ${activeStatus === ServiceStatus.UNASSIGNED ? "active" : ""}`}
                        onClick={() => handleStatusChange(ServiceStatus.UNASSIGNED, DataActions.GET_REQUESTS)}
                      >
                        <UserQuestionCircle />
                        {i18n.t("NotAllocate")}
                        {activeStatus === ServiceStatus.UNASSIGNED && (
                          <span className="status-bubble">
                            {listServices.total}
                            </span>
                        )}
                      </button>
                      <button
                        className={`btn btn-status ${activeStatus === ServiceStatus.ASSIGNED ? "active" : ""}`}
                        onClick={() => handleStatusChange(ServiceStatus.ASSIGNED, DataActions.GET_BOOKINGS)}
                      >
                        <UserCheckCircle />
                        {i18n.t("Allocate")}
                        {activeStatus === ServiceStatus.ASSIGNED && (
                          <span className="status-bubble">
                            {listServices.total}
                            </span>
                        )}
                      </button>
                      <button
                        className={`btn btn-status ${activeStatus === ServiceStatus.STARTED ? "active" : ""}`}
                        onClick={() => handleStatusChange(ServiceStatus.STARTED, DataActions.GET_BOOKINGS)}
                      >
                        <i className="bx bx-play-circle" />
                        {i18n.t("Activated")}
                        {activeStatus === ServiceStatus.STARTED && (
                          <span className="status-bubble">
                            {listServices.total}
                            </span>
                        )}
                      </button>
                    </div>
                    <div className="d-flex d-md-none w-100 justify-content-start">
                      <button className="btn btn-status w-auto" onClick={() => setShowBottomSheet(true)}>
                        <i className="bx bx-filter" /> {i18n.t("Status")}
                        <span className="status-bubble">{listServices.total}</span>
                      </button>
                    </div>
                    {showBottomSheet && (
                      <div className="bottom-sheet-overlay" onClick={() => setShowBottomSheet(false)}>
                        <div className="bottom-sheet" onClick={(e) => e.stopPropagation()}>
                          <div className="sheet-header">
                            <span>{i18n.t("ServiceStatus")}</span>
                          </div>
                          <p>{i18n.t("ServiceStatusModalText")}</p>
                          <div className="orange-separator" />
                          <div className="sheet-content d-flex flex-column gap-2">
                            <button
                              className={`btn btn-status ${activeStatus === ServiceStatus.UNASSIGNED ? "active" : ""}`}
                              onClick={() => {
                                handleStatusChange(ServiceStatus.UNASSIGNED, DataActions.GET_REQUESTS);
                                setShowBottomSheet(false);
                              }}
                            >
                              <UserQuestionCircle /> {i18n.t("NotAllocate")}
                            </button>
                            <button
                              className={`btn btn-status ${activeStatus === ServiceStatus.ASSIGNED ? "active" : ""}`}
                              onClick={() => {
                                handleStatusChange(ServiceStatus.ASSIGNED, DataActions.GET_BOOKINGS);
                                setShowBottomSheet(false);
                              }}
                            >
                              <UserCheckCircle /> {i18n.t("Allocate")}
                            </button>
                            <button
                              className={`btn btn-status ${activeStatus === ServiceStatus.STARTED ? "active" : ""}`}
                              onClick={() => {
                                handleStatusChange(ServiceStatus.STARTED, DataActions.GET_BOOKINGS);
                                setShowBottomSheet(false);
                              }}
                            >
                              <i className="bx bx-play-circle" /> {i18n.t("Activated")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="pb-2">
                  <div className="orange-separator" />
                  <Form className="row gx-3" onSubmit={autoformik.handleSubmit}>
                    {infoUser.is_staff && (
                      <Col xxl={2} md={2} xs={12}>
                        <Card className="mb-2">
                          <Select
                            name="company"
                            placeholder={i18n.t("Partner")}
                            options={listCompanies}
                            isClearable
                            className="select2-selection"
                            value={listCompanies.find((item) => item.value === fCompany) || null}
                            onChange={(e) => {
                              searchFilters(e?.value || null, FilterType.COMPANY);
                            }}
                          />
                        </Card>
                      </Col>
                    )}
                    <Col xxl={2} md={2} xs={12} className="mb-2">
                      <div className="col-sm-auto">
                        <Input
                          type="text"
                          name="serviceNumber"
                          className="form-control"
                          id="serviceNumberInput"
                          placeholder={i18n.t("ID")}
                          value={serviceNumber}
                          onChange={(e) => {
                            const value = e.target.value.trim();
                            setServiceNumber(value);
                            searchFilters(value || null, FilterType.CODE);
                          }}
                          onBlur={autoformik.handleBlur}
                          invalid={
                            autoformik.touched.serviceNumber && autoformik.errors.serviceNumber
                              ? true
                              : false
                          }
                        />
                        {autoformik.errors.serviceNumber && autoformik.touched.serviceNumber ? (
                          <FormFeedback type="invalid">
                            {autoformik.errors.serviceNumber}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    {(activeStatus === ServiceStatus.ASSIGNED || activeStatus === ServiceStatus.STARTED) && (
                      <Col xxl={2} md={2} xs={12} className="mb-2">
                        <div className="col-sm-auto">
                          <Input
                            type="text"
                            name="plateService"
                            className="form-control"
                            id="plateServiceInput"
                            placeholder={i18n.t("Plate")}
                            value={plateService}
                            onChange={(e) => {
                              const value = e.target.value.trim();
                              setPlateService(value);
                              searchFilters(value || null, FilterType.PLATE);
                            }}
                            onBlur={autoformik.handleBlur}
                            invalid={
                              autoformik.touched.plateService && autoformik.errors.plateService
                                ? true
                                : false
                            }
                          />
                          {autoformik.errors.plateService && autoformik.touched.plateService ? (
                            <FormFeedback type="invalid">
                              {autoformik.errors.plateService}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    )}
                    <Col xxl={2} md={2} xs={12}>
                      <Card className="mb-2">
                        <Select
                          name="scheduled_type"
                          placeholder={i18n.t("Type")}
                          options={listScheduledType()}
                          isClearable
                          className="select2-selection"
                          value={listScheduledType().find((item) => item.value === scheduledType) || null}
                          onChange={(e) => {
                            searchFilters(e?.value || null, FilterType.SCHEDULED);
                          }}
                        />
                      </Card>
                    </Col>
                    <Col xxl={2} md={2} xs={12} className="mb-2">
                      <div className="col-sm-auto">
                        <Select
                          name="place"
                          placeholder={i18n.t("Place")}
                          options={listPlaces()}
                          isClearable
                          className="select2-selection"
                          value={listPlaces().find((item) => item.value === placeService) || null}
                          onChange={(e) => {
                            searchFilters(e?.value || null, FilterType.PLACE);
                          }}
                        />
                        {autoformik.errors.placeService && autoformik.touched.placeService ? (
                          <FormFeedback type="invalid">
                            {autoformik.errors.placeService}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Form>
                  <div className="orange-separator" />
                </Row>
                <div className="table-responsive pt-3">
                  <Table className="table table-bordered mb-0 table-request-services">
                    {infoUser.permissions.includes(Permissions.SERVICES_READ) && (
                      <thead>
                        <tr>
                          {clickAssignService && (
                            <th>
                              <Input
                                type="checkbox"
                                id="checkAll"
                                onClick={(e) => onClickDeleteEmployee(null, "all", e)}
                              />
                            </th>
                          )}
                          <th className="company-column">{i18n.t("Company")}</th>
                          <th className="request-number-column">{i18n.t("ID")}</th>
                          {(activeStatus === ServiceStatus.ASSIGNED || activeStatus === ServiceStatus.STARTED) && (
                            <th className="plate-column">{i18n.t("Plate")}</th>
                          )}
                          <th className="origin-column">{i18n.t("Origin")} / {i18n.t("Destination")}</th>
                          <th className="date-column">{i18n.t("Date")}</th>
                          <th className="hour-column">{i18n.t("Hour")}</th>
                          <th className="type-column">{i18n.t("Type")}</th>
                          <th className="type-column">{i18n.t("Place")}</th>
                          {(activeStatus === ServiceStatus.ASSIGNED) && (
                            <th className="type-column">{i18n.t("Domicile")}</th>
                          )}
                          <th className="actions-header">{i18n.t("Actions")}</th>
                        </tr>
                      </thead>
                    )}
                    {!isLoading && !infoUser.permissions.includes(Permissions.SERVICES_READ) ? (
                      <tbody>
                        <tr>
                          <td colSpan="9" className="text-center">
                            <img
                              src={folderNoResults}
                              alt="No results"
                              className="img-no-results"
                            />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      (!isLoading && findServices.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan="9" className="text-center">
                              {showNoResults && (
                                <img
                                  src={folderNoResults}
                                  alt="No results"
                                  className="img-no-results"
                                />
                              )}
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {map(findServices, (service, key) => (
                            <CardServiceV2
                              service={service}
                              infoUser={infoUser}
                              setSelectedService={setSelectedService}
                              typeService={TypeService.REQUEST}
                              setRequestServiceCancelModal={setRequestServiceCancelModal}
                              key={"_shop_" + key}
                              clickAssignService={clickAssignService}
                            />
                          ))}
                        </tbody>
                      ))
                    )}
                  </Table>
                  {!isEmployee && (
                    <WebsocketService
                      setLoading={setLoading}
                      filtersOpts={filtersOpts}
                      uuid={infoUser.external_id}
                      listServices={listServices}
                      setListServices={setListServices}
                      reloadList={reloadList}
                      allowedActions={[
                        StreamType.REQUEST_CREATED,
                        StreamType.REQUEST_UPDATED,
                        StreamType.REQUEST_DELETED,
                      ]}
                    />
                  )}
                  <RequestServiceCancelModal
                    token={token}
                    setReloadList={setReloadList}
                    reloadList={reloadList}
                    typeService={TypeService.REQUEST}
                    isOpen={requestServiceCancelModal}
                    toggle={toggleViewModalCancelService}
                    setRequestServiceCancelModal={setRequestServiceCancelModal}
                    setShowAlertSuccess={setShowAlertSuccess}
                    setTextHeader={setTextHeader}
                    setTextBody={setTextBody}
                    setSelectedService={setSelectedService}
                    selectedService={selectedService}
                  />
                  {isLoading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                    infoUser.permissions.includes(Permissions.SERVICES_READ) && (
                      <PaginationV2
                        currentPage={currentPage}
                        pageSize={listServices.size}
                        totalItems={listServices.total}
                        onChangePage={(page) => {
                          setCurrentPage(page);
                          searchFilters(page, "page");
                        }}
                      />
                    )
                  )}
                </div>
              </CardBody>
            </Card>
          </Row>
          <AlertSuccess
            showAlertSuccess={showAlertSuccess}
            setShowAlertSuccess={setShowAlertSuccess}
            textHeader={textHeader}
            textBody={textBody}
          />
          <AlertError
            showAlertError={showAlertError}
            setShowAlertError={setShowAlertError}
            textHeader={errorHeader}
            textBody={errorBody}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default GeneralServices;
